import type { TItemType } from './items.types';

export type TPeriodicReviewItemType = Extract<TItemType, 'DOCUMENT' | 'FILE'>;

export enum EPeriodicReviewOutcome {
  NO_CHANGES_REQUIRED = 'NO_CHANGES_REQUIRED',
  CHANGES_REQUIRED = 'CHANGES_REQUIRED',
}

export const PERIODIC_REVIEW_OUTCOME_LABELS: Record<EPeriodicReviewOutcome, string> = {
  [EPeriodicReviewOutcome.NO_CHANGES_REQUIRED]: 'No changes required',
  [EPeriodicReviewOutcome.CHANGES_REQUIRED]: 'Changes required',
};

export enum EPeriodicReviewIntervalMonths {
  SIX = 6,
  TWELVE = 12,
  TWENTY_FOUR = 24,
  THIRTY_SIX = 36,
  FORTY_EIGHT = 48,
}

export type TPeriodicReviewHistoryEntry = {
  _id: string;
  reviewDate: string;
  reviewer: string;
  outcome: EPeriodicReviewOutcome;
  note?: string;
  version: string;
  comment?: string;
};

export type TPeriodicReview = {
  enabled: boolean;
  reviewIntervalMonths: EPeriodicReviewIntervalMonths;
  nextReviewDate: string;
  responsibleUser: string;
  history: TPeriodicReviewHistoryEntry[];
  reminderSentForDate?: string;
  dueSentForDate?: string;
};

export type TPeriodicReviewSettingsValues = {
  reviewIntervalMonths: EPeriodicReviewIntervalMonths;
  nextReviewDate: string;
  responsibleUser: string;
};

// The autosave payload: any subset of the editable settings fields.
export type TPeriodicReviewUpdate = Partial<TPeriodicReviewSettingsValues>;

// The single field currently autosaving (only that field disables), or null.
export type TPeriodicReviewSavingField = keyof TPeriodicReviewSettingsValues | null;
